// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/addFile.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drag-end-drop-area {
  width: 100%;
  height: 100%;
  padding: 40px;
  position: absolute;
  z-index: 10000000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(130, 170, 133, 0.8);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 30%;
  margin-left: -10px;
}

.drag-end-drop-area::after {
  content: "";
  height: 100%;
  width: 100%;
  border: 4px dotted #90ee90;
  border-radius: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/drag-and-drop-area/DragAndDropArea.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,yDAAiD;EACjD,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".drag-end-drop-area {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 40px;\r\n  position: absolute;\r\n  z-index: 10000000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(130, 170, 133, 0.8);\r\n  background-image: url(\"../../images/addFile.svg\");\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: 30%;\r\n  margin-left: -10px;\r\n}\r\n\r\n.drag-end-drop-area::after {\r\n  content: \"\";\r\n  height: 100%;\r\n  width: 100%;\r\n  border: 4px dotted #90ee90;\r\n  border-radius: 40px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
